module.exports = "<div class=\"alert\" >\n    <p [textContent]=\"message\"></p>\n    <div class=\"alert-fon\">\n        <button (click)=\"action.Closed()\">Ok</button>\n    </div>\n</div>\n<div class=\"mask-alert\">\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alert/html/alert.component.html
// module id = ./src/app/components/alert/html/alert.component.html
// module chunks = main